// React
import React, { useState } from "react";
import PropTypes from "prop-types";

// Components
import BenchmarkingCollectionsList from "./BenchmarkCollectionsList.components";
import BenchmarkingCollectionsView from "./BenchmarkCollectionsView.components";

// Functions
import { translate } from "../../utils/translation";

import Modal from "../modal/Modal";

BenchmarkCollectionsProfile.propTypes = {
  user: PropTypes.object,
  selectedCollection: PropTypes.object,
  setSelectedCollection: PropTypes.func,
  benchmarkCollections: PropTypes.object,
  benchmarking: PropTypes.array,
  setLoadedCollection: PropTypes.func,
};

export default function BenchmarkCollectionsProfile(props) {
  const [isCollectionsOpen, setIsCollectionsOpen] = useState(false);

  const { user } = props;
  const { benchmarking } = props;
  const { selectedCollection, setSelectedCollection } = props;
  const { setLoadedCollection } = props;
  const { benchmarkCollections } = props;

  return (
    <div>
      <button
        className="drawer-button"
        onClick={() => {
          setIsCollectionsOpen(!isCollectionsOpen);
        }}
      >
        Collections Menu
      </button>
      <Modal
        title={translate("Collections")}
        Component={BenchmarkingCollectionsModal}
        modal={isCollectionsOpen}
        setModal={setIsCollectionsOpen}
        // Props
        user={user}
        benchmarking={benchmarking}
        benchmarkCollections={benchmarkCollections}
        selectedCollection={selectedCollection}
        setSelectedCollection={setSelectedCollection}
        setLoadedCollection={setLoadedCollection}
      />
    </div>
  );
}

BenchmarkingCollectionsModal.propTypes = {
  user: PropTypes.object,
  selectedCollection: PropTypes.object,
  setSelectedCollection: PropTypes.func,
  benchmarkCollections: PropTypes.object,
  benchmarking: PropTypes.array,
  setLoadedCollection: PropTypes.func,
  setModal: PropTypes.func,
};

function BenchmarkingCollectionsModal(props) {
  const { benchmarking } = props;
  const { selectedCollection, setSelectedCollection } = props;
  const { setLoadedCollection } = props;
  const { benchmarkCollections } = props;
  const { user } = props;
  const { setModal } = props;

  return (
    <div className="benchmark-create-load-or-save-modal-wrapper">
      <BenchmarkingCollectionsList
        user={user}
        selectedCollection={selectedCollection}
        setSelectedCollection={setSelectedCollection}
        benchmarkCollections={benchmarkCollections}
      />
      <BenchmarkingCollectionsView
        user={user}
        benchmarking={benchmarking}
        selectedCollection={selectedCollection}
        setSelectedCollection={setSelectedCollection}
        setLoadedCollection={setLoadedCollection}
        benchmarkCollections={benchmarkCollections}
        setModal={setModal}
      />
    </div>
  );
}
